// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"c38295d5","186":"08775a7d","225":"4b84782f","272":"20811c66","372":"7b9fc182","377":"ff9c5e1b","738":"38d68588","841":"3b9b4622","849":"3c51318d","856":"c3ba7cec"}[chunkId] + ".chunk.js";
};